<div style="height: 100%; width: 100%; background: #f5f7f7">
    <div #vizContainer style="display: flex; justify-content: center"></div>
  </div>
  